module.exports = __webpack_public_path__ + "static/img/jianshiTitle.447e233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jianshiTitle.png
// module id = SVky
// module chunks = 0